
import AdditionalFieldsApi from '@/api/additionalFieldsApi'
const fields_api = new AdditionalFieldsApi()

const SET_ADDITIONAL_FIELDS_CONDITIONS = 'SET_ADDITIONAL_FIELDS_CONDITIONS'

const SET_ADDITIONAL_FIELDS_BY_ENTITY_TENDER = 'SET_ADDITIONAL_FIELDS_BY_ENTITY_TENDER'
const SET_ADDITIONAL_FIELDS_BY_ENTITY_LOTS = 'SET_ADDITIONAL_FIELDS_BY_ENTITY_LOTS'

const SET_ADDITIONAL_FIELDS_TENDER_NEW = 'SET_ADDITIONAL_FIELDS_TENDER_NEW'
const SET_ADDITIONAL_FIELDS_TENDER_EXISTS = 'SET_ADDITIONAL_FIELDS_TENDER_EXISTS'

const SET_ADDITIONAL_FIELDS_LOTS_NEW = 'SET_ADDITIONAL_FIELDS_LOTS_NEW'
const SET_ADDITIONAL_FIELDS_LOTS_EXISTS = 'SET_ADDITIONAL_FIELDS_LOTS_EXISTS'

const SET_TENDER_FLOU_STEPS = 'SET_TENDER_FLOU_STEPS'
const SET_TENDER_FLOU_STEP = 'SET_TENDER_FLOU_STEP'
const SET_FIELD_ERRORS = 'SET_FIELD_ERRORS'


const parceItems = (items) => {
  return items.map(item => ({
    ...item,
    value: item.value ?? null
  }))
}

export default {
  namespaced: true,
  state: {
    additionalFieldsByBindingConditions: [], // Доп. поля привязанные по типу тендера или классификатору

    additionalFieldsEntityTender: [], // Уже привязанные доп. поля по тендеру
    additionalFieldsEntityLots: [], // Уже привязанные доп. поля по лотам

    additionalFieldsTenderExists: [], // Существующие поля
    additionalFieldsTenderNew: [],

    additionalFieldsLotsExists: [],
    additionalFieldsLotsNew: [],
    steps: [],
    currentStep: 1, //  текущий шаг
    fieldErrors: {}
  },
  getters: {
    tenderFlouSteps: (state) => state.steps,
    fieldErrors: (state) => state.fieldErrors,
    tenderFlouCurrentStep: (state) => state.currentStep,
    tenderFlouCurrentStepProps: (state) => state.steps[state.currentStep - 1] || {},

    additionalFieldsByBindingConditions: (state) => state.additionalFieldsByBindingConditions,

    additionalFieldsEntityTender: (state) => state.additionalFieldsEntityTender,
    additionalFieldsEntityLots: (state) => state.additionalFieldsEntityLots,

    additionalFieldsTenderExists: (state) => state.additionalFieldsTenderExists,
    additionalFieldsTenderNew: (state) => state.additionalFieldsTenderNew,
    additionalFieldsTender: (state) => { return [...state.additionalFieldsTenderNew, ...state.additionalFieldsTenderExists] },

    additionalFieldsLotsExists: (state) => state.additionalFieldsLotsExists,
    additionalFieldsLotsNew: (state) => state.additionalFieldsLotsNew,
    additionalFieldsLots: (state) => { return [...state.additionalFieldsLotsNew, ...state.additionalFieldsLotsExists] }
  },
  actions: {
    setTenderFlouSteps({commit}, { values }) {
      commit(SET_TENDER_FLOU_STEPS, values)
    },
    setFieldErrors({commit}, { values }) {
      commit(SET_FIELD_ERRORS, values)
    },
    setTenderFlouCurrentStep({commit}, { value }) {
      commit(SET_TENDER_FLOU_STEP, value)
    },
    setAdditionalFieldsTenderNew({commit}, { values }) {
      commit(SET_ADDITIONAL_FIELDS_TENDER_NEW, values)
    },
    setAdditionalFieldsLotsNew({commit}, { items }) {
      commit(SET_ADDITIONAL_FIELDS_LOTS_NEW, items)
    },
    async getAdditionalFieldsByEntity({/*getters, */commit}, { tenderId }) {
      commit(SET_ADDITIONAL_FIELDS_BY_ENTITY_TENDER, [])
      commit(SET_ADDITIONAL_FIELDS_BY_ENTITY_LOTS, [])
      commit(SET_ADDITIONAL_FIELDS_TENDER_EXISTS)
      //if (!getters.additionalFieldsEntityTender?.length && !getters.additionalFieldsEntityLots?.length) {
      return await fields_api.getAdditionalFieldsByEntity({entityKey: '' + tenderId})
        .then(async (response) => {
          const additionalFieldsEntity = response || []

          const additionalFieldsEntityTender = additionalFieldsEntity
            .filter(f => f.active && f.bindingLevel == 'TENDER')?.map(field => ({
              ...field,
              value: field.fieldValues.find(values => values.entityKey == tenderId)?.value
            }))?.sort((a,b) => a.order - b.order) || []

          const additionalFieldsEntityLots = additionalFieldsEntity
            .map(i => ({...i, new: false}))
            .filter(f => f.active && f.bindingLevel == 'LOT') || []

          commit(SET_ADDITIONAL_FIELDS_BY_ENTITY_TENDER, additionalFieldsEntityTender)
          commit(SET_ADDITIONAL_FIELDS_BY_ENTITY_LOTS, additionalFieldsEntityLots)
          commit(SET_ADDITIONAL_FIELDS_TENDER_EXISTS)
        })
    },
    async getAdditionalFieldsByBindingConditions({/*getters, */commit}, { classificationCode, biddingTypeId }) {
      return await fields_api.getAdditionalFieldsByBindingConditions({
        classificationCode: classificationCode,
        biddingTypeId: biddingTypeId,
        bindingLevel: ['TENDER', 'LOT']
      }).then(async response => {
        response = response || []
        commit(SET_ADDITIONAL_FIELDS_CONDITIONS, {items: response})
        commit(SET_ADDITIONAL_FIELDS_TENDER_EXISTS)
        commit(SET_ADDITIONAL_FIELDS_LOTS_EXISTS)
      })
    },
    clearAdditionalFieldsConditions({commit}) {
      commit(SET_ADDITIONAL_FIELDS_CONDITIONS, {items: []})
    },
    setAdditionalFieldsTenderExists({commit}, { items }) {
      commit(SET_ADDITIONAL_FIELDS_TENDER_EXISTS, items)
    },
    setAdditionalFieldsLotsExists({commit}, { items }) {
      commit(SET_ADDITIONAL_FIELDS_LOTS_EXISTS, items)
    },
    clearAdditionalFields({commit}) {
      commit(SET_ADDITIONAL_FIELDS_TENDER_EXISTS, [])
      commit(SET_ADDITIONAL_FIELDS_TENDER_NEW, [])
      commit(SET_ADDITIONAL_FIELDS_LOTS_EXISTS, [])
      commit(SET_ADDITIONAL_FIELDS_LOTS_NEW, [])
    }
  },
  mutations: {
    [SET_TENDER_FLOU_STEPS](state, values) {
      state.steps = values || []
    },
    [SET_FIELD_ERRORS](state, values) {
      state.fieldErrors = values || {}
    },
    [SET_TENDER_FLOU_STEP](state, value) {
      state.currentStep = value || 1
    },
    [SET_ADDITIONAL_FIELDS_BY_ENTITY_TENDER](state, items) {
      if (items?.length) {
        state.additionalFieldsEntityTender = items || []
      } else {
        state.additionalFieldsEntityTender = []
      }
    },
    [SET_ADDITIONAL_FIELDS_BY_ENTITY_LOTS](state, items) {
      if (items?.length) {
        state.additionalFieldsEntityLots = items || []
      } else {
        state.additionalFieldsEntityLots = []
      }
    },
    [SET_ADDITIONAL_FIELDS_CONDITIONS](state, options) {
      if (options.items?.length) {
        state.additionalFieldsByBindingConditions = options.items
      } else {
        state.additionalFieldsByBindingConditions = []
      }
    },
    [SET_ADDITIONAL_FIELDS_TENDER_EXISTS](state, items) {
      if (items?.length) {
        state.additionalFieldsTenderExists = parceItems(items)
        return
      }
      const result = [...state.additionalFieldsEntityTender]
      const maxOrder = Math.max(...result.map(i => i.order)) || 0
      state.additionalFieldsByBindingConditions?.filter(f => f.active && f.bindingLevel == 'TENDER')?.forEach(resultItem => {
        const index = result?.findIndex(i => i.id === resultItem.id)
        if (index === -1) {
          result.push(resultItem)
        } else {
          result[index].order = maxOrder + 1
          /*resultItem.order = maxOrder + 1
          result[index] = resultItem*/
        }
      })
      if (result?.length) {
        state.additionalFieldsTenderExists = parceItems(result)
      } else {
        state.additionalFieldsTenderExists = []
      }
    },
    [SET_ADDITIONAL_FIELDS_TENDER_NEW](state, items) {
      if (items?.length) {
        state.additionalFieldsTenderNew = parceItems(items)
      } else {
        state.additionalFieldsTenderNew = []
      }
    },
    [SET_ADDITIONAL_FIELDS_LOTS_NEW](state, items) {
      if (Array.isArray(items) && items.length === 0) {
        state.additionalFieldsLotsNew = []
        return
      }
      if (items?.length) {
        state.additionalFieldsLotsNew = parceItems(items)
      } else {
        state.additionalFieldsLotsNew = []
      }
    },

    [SET_ADDITIONAL_FIELDS_LOTS_EXISTS](state, items,) {
      if (Array.isArray(items) && items.length === 0) {
        state.additionalFieldsLotsExists = []
        return
      }
      if (items?.length) {
        state.additionalFieldsLotsExists = parceItems(items)
        return
      }
      const result = [...state.additionalFieldsEntityLots]
      const maxOrder = Math.max(...result.map(i => i.order)) || 0
      state.additionalFieldsByBindingConditions?.filter(f => f.active && f.bindingLevel == 'LOT')?.forEach(resultItem => {
        const index = result?.findIndex(i => i.id === resultItem.id)
        if (index === -1) {
          result.push(resultItem)
        } else {
          resultItem.fieldValues = result[index].fieldValues
          resultItem.order = maxOrder + 1
          result[index] = resultItem
        }
      })
      if (result?.length) {
        state.additionalFieldsLotsExists = parceItems(result)
      } else {
        state.additionalFieldsLotsExists = []
      }
    }
  },
}
